import { FormControlLabel, Radio, RadioGroup, Typography } from "@mui/material";

import { useFilterContext } from "../FilterContext";

const FilterItemStops = () => {
  const { filterData, setFilterData, filterOptions } = useFilterContext();
  return (
    <RadioGroup
      aria-labelledby="demo-controlled-radio-buttons-group"
      name="controlled-radio-buttons-group"
      value={filterData.stops}
      onChange={(e) => {
        setFilterData({
          stops: e.target.value,
        });
      }}
    >
      {filterOptions.stopsOptions.map((item, index) => (
        <FormControlLabel
          key={index}
          value={item.value}
          control={<Radio />}
          label={<Typography color={"textPrimary"}>{item.label}</Typography>}
        />
      ))}
    </RadioGroup>
  );
};

export default FilterItemStops;
